export let mockTelefone = {
  id: null,
  purpose: null,
  areaCode: 55,
  phoneNumber: null,
  cellphone: false,
  default: false,
  active: true
}
